if (!customElements.get('all-courses-and-events-filter')) {
  class AllCoursesAndEventsFilter extends HTMLElement {
    constructor() {
      super();
      this.checkboxes = this.querySelectorAll('[data-filter-checkbox]');
      this.grid = this.querySelector('[data-courses-events-grid]');
      this.items = this.querySelectorAll('.all-courses-and-events__item');
      this.emptyMessage = this.querySelector('[data-empty-message]');

      if (!this.grid || this.items.length === 0) return;

      this.init();
    }

    init() {
      for (const checkbox of this.checkboxes) {
        checkbox.addEventListener('change', () => this.filterItems());
      }
    }

    filterItems() {
      const activeFilters = [];

      for (const checkbox of this.checkboxes) {
        if (checkbox.checked) {
          activeFilters.push(checkbox.value);
        }
      }

      let visibleCount = 0;

      for (const item of this.items) {
        const itemType = item.dataset.type;

        if (activeFilters.length === 0 || activeFilters.includes(itemType)) {
          item.hidden = false;
          visibleCount++;
        } else {
          item.hidden = true;
        }
      }

      // Show empty message if no items are visible
      if (this.emptyMessage) {
        if (visibleCount === 0) {
          this.emptyMessage.hidden = false;
        } else {
          this.emptyMessage.hidden = true;
        }
      }
    }
  }

  customElements.define('all-courses-and-events-filter', AllCoursesAndEventsFilter);
}
